import i18n from '../i18n';

export const getBikeTypeName = (bikeTypesByTenant, tenant, bikeTypeId) => {
  if (!bikeTypeId) {
    return i18n.t('plans.bikeType.all');
  }

  const bikeTypes = bikeTypesByTenant[tenant] || [];
  const bikeType = bikeTypes.find(type => type.id === bikeTypeId);

  return bikeType ? bikeType.name : i18n.t('plans.bikeType.unknown');
};

export const planConflictsWithActivePlan = (plan, activePlans) =>
  activePlans.some(activePlan =>
    activePlan.tenantId === plan.tenant &&
    (!plan.bikeTypeId || !activePlan.bikeTypeId || activePlan.bikeTypeId === plan.bikeTypeId)
  );
